module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-empty"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/images/404-template.png")
    }
  }), _c('div', {
    staticClass: "legend"
  }, [_vm._v(_vm._s(_vm.$t('template.feedback.noDataText')))]), _c('router-link', {
    staticClass: "btn btn-primary",
    attrs: {
      "to": "/templates/criar"
    }
  }, [_c('span', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('template.actions.new')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3f75a2ca!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/empty.vue
// module id = 1087
// module chunks = 1